import { render, staticRenderFns } from "./courseListModal.vue?vue&type=template&id=05f92680&scoped=true&"
import script from "./courseListModal.vue?vue&type=script&lang=js&"
export * from "./courseListModal.vue?vue&type=script&lang=js&"
import style0 from "./courseListModal.vue?vue&type=style&index=0&id=05f92680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f92680",
  null
  
)

export default component.exports